<template>
  <a 
    :href="url" 
    class="c-bookButton" 
    target="_blank" 
    @click="onClicked"
    @mouseenter="onMouseenter" 
    @mouseleave="onMouseleave">
    <span class="c-bookButton__text"><slot>Book Now</slot> <i class="icon-external"></i></span>
    <span class="c-bookButton__layer" ref="layer"></span>
  </a>
</template>

<script>
  import { TweenMax } from 'gsap'
  /**
   * Share Partial
   */

  export default {
    name: 'book-button',
    data() {
      return {
        tween: null,
      }
    },
    props: {
      url: {
        type: String,
        required: true
      },
      eventLabel: ''
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
      onMouseenter() {
        if(TweenMax.isTweening(this.$refs.layer)) {
          TweenMax.to(this.$refs.layer, 0, {
            x: -this.$window.width,
            scaleX: 1,
          })
        }

        this.tween = TweenMax.fromTo(this.$refs.layer, 0.8, {
          x: -this.$window.width,
          scaleX: 1,
        },{
          ease: Power4.easeInOut,
          x: 0
        })
      },
      onMouseleave() {
        let delay = 0

        if(TweenMax.isTweening(this.$refs.layer)) {
          TweenMax.to(this.$refs.layer, 0.4, {
            x: 0,
            scaleX: 1,
          })

          delay = 0.4;
        }

        TweenMax.fromTo(this.$refs.layer, 0.8, {
          scaleX: 1,
          delay,
        }, {
          ease: Power4.easeInOut,
          scaleX: 0,
          
        })
      },
      onClicked() {
        this.$ga.event('accommodation', 'click', this.eventLabel);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/book-button.vue